import { NavLink } from 'react-router-dom'
import { ROUTES } from '@metal/shared'
import { Icon, type IconName } from '@metal/ui'
import { useSession } from '@metal/ui/session'
import { useTradeSide, type TradeSide } from '@/lib/trade-side'

/**
 * Five rows, and deliberately not the five desktop rows: «پیشنهادهای من» is
 * reached from the account tab and from the offer sheet, because a phone tab
 * bar with six rows is a tab bar nobody hits accurately.
 *
 * The second row opens the member's listings on the side they are working on
 * (see trade-side), the way the desktop «عرضه و تقاضا» row does; the list page
 * itself switches between عرضه‌ها and تقاضاها.
 */
function tabs(side: TradeSide): Array<{ to: string; label: string; icon: IconName }> {
  const sells = side === 'sell'
  return [
    { to: ROUTES.board(), label: 'تابلو', icon: 'chart' },
    sells
      ? { to: ROUTES.myOffers(), label: 'عرضه و تقاضا', icon: 'cathode' }
      : { to: ROUTES.myRfqs(), label: 'عرضه و تقاضا', icon: 'list' },
    { to: ROUTES.deals(), label: 'معاملات', icon: 'doc' },
    { to: ROUTES.wallet(), label: 'کیف پول', icon: 'wallet' },
    { to: ROUTES.settingsProfile(), label: 'حساب کاربری', icon: 'user' },
  ]
}

export function MobileTabBar() {
  const { user } = useSession()
  const [side] = useTradeSide(user?.sides ?? [])

  return (
    <nav className="tabbar" aria-label="منوی پایین صفحه">
      {tabs(side).map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => (isActive ? 'is-on' : undefined)}>
          <Icon name={t.icon} />
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
